import React from 'react'
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
const XLSX = require("xlsx");
function AfterOptimizationTable({ filteredplotdata1,corevalue,distributionvalue,distributionvaluecontri }) {
  filteredplotdata1=filteredplotdata1?.sort((a,b)=>a.variable.localeCompare(b.variable))
  const hidingvariablelist = ExceptionVariables?.hiddenvariables;
  const downloadtabledata=()=>{
     const data = [];

        const headers = [];
        
        //headers.push("Scenario")
        headers.push("Variables")
       
        headers.push("Planned")
        headers.push("Optimized")
        headers.push("Change(%)")
        headers.push("Unit")
    
     
        data.push(headers);
        const totalspends=[
          {
variable:"Total Spends (Lacs)",
planned_spends:(filteredplotdata1?.filter((it) =>  it.variable !== "sales" )?.reduce((prev, next) => prev + next.planned_spends, 0) / 100000)?.toFixed(3),
optimized_spends:(filteredplotdata1?.filter((it) => it.variable !== "sales"   )?.reduce((prev, next) => prev + next.optimized_spends, 0) / 100000)?.toFixed(3),
percentage_difference:`${((
                (
                  (filteredplotdata1
                    ?.filter((it) => it.variable !== "sales"   )
                    ?.reduce((prev, next) => prev + next.optimized_spends, 0) -
                    filteredplotdata1
                      ?.filter((it) => it.variable !== "sales"   )
                      ?.reduce((prev, next) => prev + next.planned_spends, 0)
                  ) /
                  filteredplotdata1
                    ?.filter((it) => it.variable !== "sales"   )
                    ?.reduce((prev, next) => prev + next.planned_spends, 0)
                ) * 100)?.toFixed(3))}%`
          },
       

        ]
        const totalsales=[   { variable:"Total Sales(Kg Tonnes)",
          planned_spends:(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends / 1000)?.toFixed(3),
          optimized_spends:(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.optimized_spends / 1000)?.toFixed(3),
        percentage_difference:` ${

              ((
                Number(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.optimized_spends) -
                Number(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends))
                / filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends * 100)?.toFixed(3)
            }%`
      }]
        totalspends?.map((row)=>{
          const variables= row.variable;
          const unit="Lacs"
          const planned= row.planned_spends;
          const optimized= row.optimized_spends;
          const differencepercentage= row.percentage_difference;
         
            data.push([variables,planned,optimized,differencepercentage,unit]);
        })
        totalsales?.map((row)=>{
          const variables= row.variable;
          const unit="Kg Tonnes"
          const planned= row.planned_spends;
          const optimized= row.optimized_spends;
          const differencepercentage= row.percentage_difference;
         
          data.push([variables,planned,optimized,differencepercentage,unit]);
        })
        filteredplotdata1?.map((row)=>{
          const variables= row.variable;
          const unit="Lacs"
          const planned= (row.planned_spends/100000).toFixed(3);
          const optimized= (row.optimized_spends/100000).toFixed(3);
          const differencepercentage= `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned_spends !== 0 ? ((row.optimized_spends - row.planned_spends) / (row.planned_spends) * 100).toFixed(1) : 0}%`;
    
            data.push([variables,planned,optimized,differencepercentage,unit]);
        })
        corevalue?.map((row)=>{
          const variables= row.core_incremental_media;
          const unit="Lacs"
          const planned= (row.planned_spends/100000).toFixed(3);
          const optimized= (row.optimized_spends/100000).toFixed(3);
          const differencepercentage= `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned_spends !== 0 ? ((row.optimized_spends - row.planned_spends) / (row.planned_spends) * 100).toFixed(1) : 0}%`;
     
            data.push([variables,planned,optimized,differencepercentage,unit]);
        })
    
        distributionvalue?.length>0 &&
        distributionvalue?.map((row)=>{
          const variables= row.variable_name;
          const unit="Number"
          const planned= row.planned;
          const optimized= row.optimized;
          const differencepercentage= `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row !== 0 ? ((row.optimized- row.planned) / (row.planned) * 100).toFixed(1) : 0}%`;
  
            data.push([variables,planned,optimized,differencepercentage,unit]);
        })
        distributionvaluecontri?.length>0 &&
        distributionvaluecontri?.map((row)=>{
          const variables= row.variable_name;
          const unit="Kg Tonnes"
          const planned= row.planned/1000;
          const optimized= row.optimized/1000;
          const differencepercentage= `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned !== 0 ? ((row.optimized - row.planned) / (row.planned) * 100).toFixed(1) : 0}%`;
          // const brand= row.brand;
          //   const market = row.market;
          //   const lastfy = row.lastfy;
          //   const lastmape =`${(row.lastmape*100).toFixed(1)}%`;
          //   const currentfy =row.currentfy;
          //   const currentmape=`${(row.currentmape*100).toFixed(1)}%`;
          data.push([variables,planned,optimized,differencepercentage,unit]);
        })
        // Create a new workbook
        const workbook = XLSX.utils.book_new();
    
        // Create a new worksheet and add data to it
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
        // Convert the workbook to a binary Excel file
        const excelBuffer = XLSX.write(workbook, { type: "array" });
    
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        // Create a URL from the Blob
        const url = URL.createObjectURL(blob);
    
        // Create a download link and trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.download = `OptimizationResults.xlsx`;
        link.click();
    
    
  }
  return (
    <>
    {filteredplotdata1?.length > 0 &&
             
        <div className='d-flex flex-row-reverse'>

     
                 <button className="btn btn-secondary" onClick={downloadtabledata} >
                    <i className="mx-1 fa fa-download"></i>
                 </button>   </div>
             }
      <table className="container my-3 table table-striped table-bordered">
        <thead className="text-white bg-secondary ">
          <th >Total</th>
          <th className='text-right'>Planned  </th>
          <th className='text-right'>Optimized   </th>
          <th className='text-right'>Diff (%)</th>
        </thead>
        <tbody>

          <tr >
            <td className=" ">Total Spends (Lacs)</td>

            <td className="text-right"> {(filteredplotdata1?.filter((it) =>  it.variable !== "sales" )?.reduce((prev, next) => prev + next.planned_spends, 0) / 100000)?.toFixed(3)}</td>
            <td className="text-right">{(filteredplotdata1?.filter((it) => it.variable !== "sales"   )?.reduce((prev, next) => prev + next.optimized_spends, 0) / 100000)?.toFixed(3)}</td>

            <td className="text-right">
              {((
                (
                  (filteredplotdata1
                    ?.filter((it) => it.variable !== "sales"   )
                    ?.reduce((prev, next) => prev + next.optimized_spends, 0) -
                    filteredplotdata1
                      ?.filter((it) => it.variable !== "sales"   )
                      ?.reduce((prev, next) => prev + next.planned_spends, 0)
                  ) /
                  filteredplotdata1
                    ?.filter((it) => it.variable !== "sales"   )
                    ?.reduce((prev, next) => prev + next.planned_spends, 0)
                ) * 100)?.toFixed(3))}%
            </td>

          </tr>
          <tr >
            <td  className="">Total Sales (Kg Tonnes)</td>

            <td className="text-right">{(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends / 1000)?.toFixed(3)}</td>
            <td className="text-right">{(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.optimized_spends / 1000)?.toFixed(3)}</td>
            <td className='text-right'>
              {

                ((
                  Number(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.optimized_spends) -
                  Number(filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends))
                  / filteredplotdata1?.filter((it) => it.variable === "sales")[0]?.planned_spends * 100)?.toFixed(3)
              }%
            </td>



          </tr>

        </tbody>
      </table>
      <table className="container my-3 table table-striped table-bordered" style={{ fontSize: "2vh" }}>
        <thead className="text-white bg-secondary ">
          <th >Marketing Variables</th>
          <th className='text-right'>Planned Spends (Lacs)</th>
          <th className='text-right'>Optimized Spends (Lacs)</th>
          <th className='text-right'>Change(%)</th>
        </thead>

        <tbody>
          {filteredplotdata1?.map((item) => {
            return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
              <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.planned_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.optimized_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>
                {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized_spends - item.planned_spends) / (item.planned_spends) * 100).toFixed(1) : 0}%
                </td>
            </tr>
          })}
        </tbody>
      </table>
      {/* <div className="container my-2 text-primary">Core Variables</div> */}
      {corevalue.length>0 &&
      <table className="container my-3 table table-bordered" style={{ fontSize: "2vh" }}>
        <thead className="text-white bg-secondary ">
          <th >Variable Type</th>
          <th className='text-right'>Planned Spends (Lacs)</th>
          <th className='text-right'>Optimized Spends (Lacs)</th>
          <th className='text-right'>Change(%)</th>
        </thead>

        <tbody>
          { corevalue?.map((item) => {
            return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
              <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.core_incremental_media}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.planned_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.optimized_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>
                {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized_spends - item.planned_spends) / (item.planned_spends) * 100).toFixed(1) : 0}%
                </td>
            </tr>
          })}
        </tbody>
      </table>}

    {(distributionvalue?.length>0 || distributionvaluecontri?.length>0) && 
      <table className="container my-3 table table-bordered" style={{ fontSize: "2vh" }}>
        <thead className="text-white bg-secondary ">
          <th >Variable</th>
          <th className='text-right'>Planned  </th>
          <th className='text-right'>Optimized  </th>
          <th className='text-right'>Change(%)</th>
        </thead>

        <tbody>
          {distributionvalue?.length>0 && distributionvalue?.map((item) => {
            return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
              <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable_name}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.planned ?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{(item?.optimized ?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>
                {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized - item.planned) / (item.planned) * 100).toFixed(1) : 0}%
                </td>
            </tr>
          })}
           {distributionvaluecontri?.length>0 && distributionvaluecontri?.map((item) => {
            return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
              <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable_name}{" "}(Kg Tonnes)</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{((item?.planned/1000) ?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>{((item?.optimized/1000) ?.toFixed(3))?.toLocaleString("en-IN")}</td>
              <td className={item.variable === "sales" ? "bg-success text-white text-right" : " text-right"}>
                {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized - item.planned) / (item.planned) * 100).toFixed(1) : 0}%
                </td>
            </tr>
          })}
        </tbody>
      </table>}
    </>
  )
}

export default AfterOptimizationTable